import getURL from "./url"

//import base logo
import NoImg from "@/assets/no-image.png"

export function getAllergies(meal, userStore) {
	if (!userStore?.user) return []
	//make user as acting user
	const user = userStore.actingAsUser || userStore.user
	//no allergies or no user allergies
	if (!meal.entry.allergens || !user.allergies) return []

	const userAllergies = user.allergies
		.split(",")
		.map((a) => a.trim().toLowerCase())

	const allergyRegex = new RegExp(userAllergies.join("|"), "i")

	return meal.entry.allergens.filter((a) => allergyRegex.test(a))
}

export function getAllergiesCount(meal, userStore) {
	return getAllergies(meal, userStore).length
}

export function getImageSource(img) {
	if (
		img &&
		(img.startsWith("food") ||
			img.startsWith("drink") ||
			img.startsWith("leftovers"))
	) {
		// if (Capacitor.isNativePlatform()) {
		// 	return `https://bucket.grubvision.com/${img}`
		// }
		// return `/api/image/${img}`
		return getURL("image", img)
	} else {
		return img ? "data:image/png;base64," + img : NoImg //"https://placehold.co/600x400"
	}
}

//no longer need to be exported
function getDrinkDescription(meal) {
	// A beverage to qunich your thrist.
	return `${meal.entry.drink_size} ${meal.entry.drink_container_material} ${meal.entry.drink_container_type}.`
}

export function getName(meal) {
	return meal.entry.meal_name ?? meal.entry.drink_name ?? meal.entry.title
}

export function getCookTypeColor(type) {
	if (type === "restaurant") {
		return "bg-danger"
	}
	return "bg-secondary"
}

export function getMealTypeColor(type) {
	return "bg-primary"
}

export function getDescription(meal) {
	return (
		meal.entry.image_description ??
		(meal.entry.drink_name ? getDrinkDescription(meal) : null) ??
		meal.entry.description ??
		""
	)
}
